import * as React from 'react'
import { IServiceLocationObject } from 'src/types'

export interface ILocationListItemProps {
  location: IServiceLocationObject
}

class ServiceLocationListItem extends React.Component<ILocationListItemProps> {
  constructor(props: ILocationListItemProps) {
    super(props)
  }

  public render() {
    const { location } = this.props
    if (!location) {
      return null
    }

    const addressParts = location.fullAddress.split(',')
    const shortAddress = addressParts[0] + ', ' + addressParts[1]

    return (
      <div>
        <div>
          <div className='flex'>
            <div className='col-3'>
              <span className='h5'>{location.placeName}</span>
            </div>
            <div className='col-2'>
              <span className='h5'>{location.phoneNumber}</span>
            </div>
            <div className='col-4'>
              {/* TODO: Add map widget & icon */}
              <span className='h5'>{shortAddress}</span>
            </div>
            <div className='col-3'>
              <span className='h5'>{location.note}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ServiceLocationListItem



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceLocationListItem.tsx